import { createI18n } from 'vue-i18n';
import locale from './locale'


const i18n = createI18n({
  locale: localStorage.language || 'cn', // 语言标识
  messages: locale,
})
export default i18n